import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import Link from 'components/consumer/Link';
import IconUserAccount from 'components/icons/iconUserAccount';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
const MobileNavbarLink = t0 => {
  const $ = _c(16);
  const {
    children,
    id,
    isNested: t1,
    to,
    currentPage
  } = t0;
  const isNested = t1 === undefined ? false : t1;
  const locationFromRoute = useUserCurrentPageType();
  const location = currentPage ?? locationFromRoute;
  let t2;
  if ($[0] !== children || $[1] !== location || $[2] !== to) {
    t2 = children === "Room Visualizer" || children === "Room Refresh" ? () => {
      avo.ctaClicked({
        text: children,
        targetUrl: to,
        cta: "Room Visualizer",
        location,
        component: "Navbar"
      });
    } : undefined;
    $[0] = children;
    $[1] = location;
    $[2] = to;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isNested) {
    t3 = classNames("text-lg !text-gray flex justify-start px-5 py-3 no-underline hover:underline focus-visible:rounded-[3px] focus-visible:outline-offset-[-4px] flex-col items-start max-w-full", {
      "pt-2 px-[42px] pb-[9px]": isNested
    });
    $[4] = isNested;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== id) {
    t4 = id === "login" && <IconUserAccount className="mr-4 relative top-[-2px]" />;
    $[6] = id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children) {
    t5 = <span className="MobileNavbarLink__text">{children}</span>;
    $[8] = children;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== to) {
    t6 = <Link to={to} onClick={t2} className={t3} id={to}>{t4}{t5}</Link>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = to;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
MobileNavbarLink.propTypes = {
  children: PropTypes.string,
  id: PropTypes.string,
  isNested: PropTypes.bool,
  to: PropTypes.string,
  currentPage: PropTypes.objectOf(PropTypes.object)
};
export default MobileNavbarLink;